// Charge la base commune
import './common.js'

// Ground Alert Form
async function getGAForm ($f) {
  import(/* webpackChunkName: "groundsAlertForm", webpackPrefetch: true */ './js/components/groundsAlertForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire d'inscription aux alertes terrain
  const $f = $('form[name="gaForm"]')
  $f.waypoint(function () {
    $f.load()
    getGAForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })
})
